<template>
  <div class="sarvban-overlay" v-if="isVisible" @click.self="close">
    <div class="sarvban-modal">
        <button class="sarvban-close" @click="close" :aria-label="$t('contactModal.close')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>
        </button>

        <div class="sarvban-hero">
          <div class="sarvban-shield">
            <svg width="40" height="40" viewBox="0 0 48 48" fill="none">
              <path d="M24 4L6 12v8c0 14 8 22 18 24 10-2 18-10 18-24v-8L24 4z" fill="currentColor" opacity="0.12"/>
              <path d="M24 4L6 12v8c0 14 8 22 18 24 10-2 18-10 18-24v-8L24 4z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
              <path d="M16 24l5 5 11-11" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="sarvban-title">{{ $t('contactModal.hero_title') }}</h2>
          <p class="sarvban-tagline">{{ $t('contactModal.hero_tagline') }}</p>
        </div>

        <div class="sarvban-body">
          <p class="sarvban-desc">
            {{ $t('contactModal.desc_1') }}
          </p>
          <p class="sarvban-desc">
            {{ $t('contactModal.desc_2') }}
          </p>
        </div>

        <div class="sarvban-section">
          <div class="sarvban-section-header">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            <span>{{ $t('contactModal.steps_title') }}</span>
          </div>
          <div class="steps">
            <div class="step">
              <span class="step-num">۱</span>
              <div class="step-body">
                <strong class="step-title">{{ $t('contactModal.step1_title') }}</strong>
                <p class="step-desc">{{ $t('contactModal.step1_desc') }}</p>
              </div>
            </div>
            <div class="step-connector">
              <svg width="12" height="20" viewBox="0 0 12 24" fill="none"><path d="M6 0v18M2 14l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <div class="step">
              <span class="step-num">۲</span>
              <div class="step-body">
                <strong class="step-title">{{ $t('contactModal.step2_title') }}</strong>
                <p class="step-desc">{{ $t('contactModal.step2_desc') }}</p>
              </div>
            </div>
            <div class="step-connector">
              <svg width="12" height="20" viewBox="0 0 12 24" fill="none"><path d="M6 0v18M2 14l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <div class="step">
              <span class="step-num">۳</span>
              <div class="step-body">
                <strong class="step-title">{{ $t('contactModal.step3_title') }}</strong>
                <p class="step-desc">{{ $t('contactModal.step3_desc') }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="sarvban-section">
          <div class="sarvban-section-header">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            <span>{{ $t('contactModal.benefits_title') }}</span>
          </div>
          <div class="benefits">
            <div class="benefit">
              <svg class="benefit-icon" width="16" height="16" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M6 10l3 3 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              <span>{{ $t('contactModal.benefit1') }}</span>
            </div>
            <div class="benefit">
              <svg class="benefit-icon" width="16" height="16" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M6 10l3 3 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              <span>{{ $t('contactModal.benefit2') }}</span>
            </div>
            <div class="benefit">
              <svg class="benefit-icon" width="16" height="16" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M6 10l3 3 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              <span>{{ $t('contactModal.benefit3') }}</span>
            </div>
            <div class="benefit">
              <svg class="benefit-icon" width="16" height="16" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M6 10l3 3 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              <span>{{ $t('contactModal.benefit4') }}</span>
            </div>
          </div>
        </div>

        <div class="sarvban-code">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>
          <div class="sarvban-code-text">
            <span>{{ $t('contactModal.tracking_code') }} <strong>{{ code }}</strong></span>
            <small>{{ $t('contactModal.code_hint_text') }}</small>
          </div>
        </div>

        <div class="sarvban-contact">
          <div class="contact-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>
            <div>
              <strong>{{ $t('contactModal.product_status') }}</strong>
              <a href="tel:09422054321" dir="ltr">09422054321</a>
              <small>{{ $t('contactModal.ext_internal') }}</small>
            </div>
          </div>
          <div class="contact-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            <div>
              <strong>{{ $t('contactModal.networks_label') }}</strong>
              <a href="https://wa.me/989332213064" target="_blank" dir="ltr">09332213064</a>
            </div>
          </div>
        </div>

        <div class="sarvban-actions">
          <button class="btn-order" @click="handleOrder">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
            <span>{{ $t('contactModal.order_btn') }}</span>
          </button>
          <button class="btn-later" @click="close">{{ $t('contactModal.later_btn') }}</button>
        </div>
      </div>
    </div>
</template>

<script setup>
const props = defineProps({
  product: { type: Object, required: true }
})
const emit = defineEmits(['close', 'order'])

const router = useRouter()
const localePath = useLocalePath()
const isVisible = ref(true)

const code = computed(() => props.product.invoiceNum || props.product.id || '—')

const close = () => {
  isVisible.value = false
  setTimeout(() => emit('close'), 200)
}

const handleOrder = () => {
  const orderPath = localePath(`/order/${props.product.invoiceNum || props.product.id}`)
  close()
  setTimeout(() => router.push(orderPath), 250)
}

</script>

<style lang="scss" scoped>
.sarvban-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  direction: rtl;
  font-family: 'IRANYekan', 'Vazirmatn', sans-serif;
}

.sarvban-modal {
  position: relative;
  width: 100%;
  max-width: 480px;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: #d0d0d0; border-radius: 4px; }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.sarvban-close {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.04);
  color: #888;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.08);
    color: #333;
  }
}

.sarvban-hero {
  text-align: center;
  padding: 36px 24px 16px;
  background: linear-gradient(180deg, #f0fdf4 0%, #fff 100%);
  border-radius: 16px 16px 0 0;
}

.sarvban-shield {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #03a054, #1a6b3c);
  color: #fff;
  margin-bottom: 12px;
  box-shadow: 0 6px 20px rgba(3, 160, 84, 0.25);
}

.sarvban-title {
  margin: 0 0 4px;
  font-size: 1.2rem;
  font-weight: 800;
  color: #124d2a;
  line-height: 1.4;
}

.sarvban-tagline {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 500;
  color: #6cb17a;
}

.sarvban-body {
  padding: 12px 24px 4px;
}

.sarvban-desc {
  margin: 0 0 10px;
  font-size: 0.84rem;
  line-height: 1.8;
  color: #444;
}

.sarvban-section {
  padding: 12px 24px 4px;
}

.sarvban-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 0.85rem;
  font-weight: 700;
  color: $olive-dark;

  svg {
    flex-shrink: 0;
    color: $leaf;
  }
}

.steps {
  padding-right: 0;
}

.step {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.step-num {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, $leaf, $olive-dark);
  box-shadow: 0 3px 8px rgba(3, 160, 84, 0.25);
  margin-top: 1px;
}

.step-body {
  flex: 1;
  min-width: 0;
}

.step-title {
  display: block;
  font-size: 0.88rem;
  font-weight: 700;
  color: $ink;
  margin-bottom: 2px;
}

.step-desc {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.6;
  color: $ink-soft;
}

.step-connector {
  display: flex;
  justify-content: center;
  padding: 2px 0 2px 15px;
  color: #d4d4d4;

  svg { width: 12px; height: 22px; }
}

.benefits {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.benefit {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f8fdfa;
  border-radius: 10px;
  border: 1px solid #e6f4ec;
  font-size: 0.82rem;
  font-weight: 500;
  color: $ink;
  line-height: 1.5;
}

.benefit-icon {
  flex-shrink: 0;
  color: $leaf;
}

.sarvban-code {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 16px 24px 0;
  padding: 12px 14px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 10px;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: #d97706;
  }
}

.sarvban-code-text {
  font-size: 0.82rem;
  color: #92400e;
  line-height: 1.6;

  strong { font-weight: 800; }

  small {
    display: block;
    font-size: 0.72rem;
    color: #b45309;
    margin-top: 2px;
  }
}

.sarvban-contact {
  margin: 16px 24px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f8f9fa;
  border-radius: 10px;
  border: 1px solid $line;
  color: $ink;
  transition: background 0.2s;

  &:hover {
    background: #f0f1f3;
  }

  svg {
    flex-shrink: 0;
    color: $leaf;
  }

  div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 8px;
    font-size: 0.82rem;
  }

  strong {
    font-size: 0.8rem;
    color: $ink;
    width: 100%;
  }

  a {
    color: $leaf;
    text-decoration: none;
    font-weight: 600;
    direction: ltr;
    display: inline-block;

    &:hover { color: $leaf-deep; text-decoration: underline; }
  }

  small {
    color: $ink-soft;
    font-size: 0.75rem;
  }
}

.sarvban-actions {
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.btn-order {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 20px;
  border: none;
  border-radius: 12px;
  font-family: inherit;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  background: linear-gradient(135deg, $leaf, $olive-dark);
  color: #fff;
  box-shadow: 0 4px 16px rgba(3, 160, 84, 0.35);
  transition: all 0.25s ease;
  animation: pulseCta 2s ease-in-out infinite;

  &:hover {
    box-shadow: 0 6px 24px rgba(3, 160, 84, 0.45);
    transform: translateY(-1px);
  }

  &:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(3, 160, 84, 0.3);
    animation: none;
  }

  svg { flex-shrink: 0; }
}

@keyframes pulseCta {
  0%, 100% { box-shadow: 0 4px 16px rgba(3, 160, 84, 0.35); }
  50% { box-shadow: 0 4px 24px rgba(3, 160, 84, 0.55); }
}

.btn-later {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  background: transparent;
  color: #999;
  transition: all 0.2s;

  &:hover {
    background: #f5f5f5;
    color: $ink-soft;
  }
}

@media (max-width: 480px) {
  .sarvban-modal {
    max-height: 95vh;
    border-radius: 12px;
  }

  .sarvban-hero {
    padding: 28px 20px 12px;
  }

  .sarvban-body,
  .sarvban-section {
    padding-right: 18px;
    padding-left: 18px;
  }

  .sarvban-code,
  .sarvban-contact {
    margin-right: 18px;
    margin-left: 18px;
  }

  .sarvban-actions {
    padding: 16px 18px 20px;
  }

  .sarvban-title {
    font-size: 1.05rem;
  }
}
</style>
